import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@/storybook/components/Button/Button';
import Text from '@/storybook/components/Text/Text';
import ArrowRightIcon from '@/storybook/icons/ArrowRightIcon';
import { TestIds } from './testIds';
import styles from './QuickQuestions.module.css';

export interface QuickQuestionsProps {
  questions: ReadonlyArray<string>;
  onQuestionClick: (question: string) => void;
}

const QuickQuestions: FC<QuickQuestionsProps> = ({ questions, onQuestionClick }) => {
  const { t } = useTranslation();

  if (questions.length === 0) {
    return null;
  }

  return (
    <div
      className={styles.container}
      aria-label={t('components.aiChatDrawer.quickQuestions.ariaLabel')}
      data-testid={TestIds.container}
    >
      <Text as="span" className={styles.title} data-testid={TestIds.title}>
        {t('components.aiChatDrawer.quickQuestions.title')}
      </Text>

      <ul className={styles.list} role="list" data-testid={TestIds.list}>
        {questions.map((question, questionIndex) => (
          <li key={`${question}-${questionIndex}`} role="listitem">
            <Button
              variant="text"
              size="L"
              className={styles.item}
              onClick={() => onQuestionClick(question)}
              aria-label={t('components.aiChatDrawer.quickQuestions.itemAriaLabel', { question })}
              data-testid={TestIds.item}
              endIcon={<ArrowRightIcon className={styles.itemIcon} aria-hidden="true" />}
            >
              <Text as="span" className={styles.itemLabel}>
                {question}
              </Text>
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default QuickQuestions;
